import type { PLCConfiguration } from '@/models/types/plc/plc-configuration'
import type { ConfigPlcDto } from '../../dto/plc/config-plc-dto'

const mapToPLCConfiguration = (configPlcDto: ConfigPlcDto): PLCConfiguration => {
    return {
        id: configPlcDto.id,
        send: configPlcDto.invio,
        dataType: configPlcDto.tipoDato,
        globalSamplingTime: configPlcDto.tCampionamentoGlobale ?? undefined,
        recordingStartTime: configPlcDto.tInizioRegistrazione ?? undefined,
        recordingEndTime: configPlcDto.tFineRegistrazione ?? undefined,
        recordingTime: configPlcDto.tTempoRegistrazione ?? undefined,
        samplingFrequency: configPlcDto.iSamplingFrequency,
        variant: configPlcDto.variant,
    }
}

const mapToConfigPlcDto = (plcConfiguration: PLCConfiguration): ConfigPlcDto => {
    return {
        id: plcConfiguration.id,
        invio: plcConfiguration.send,
        tipoDato: plcConfiguration.dataType,
        tCampionamentoGlobale: plcConfiguration.globalSamplingTime ?? null,
        tInizioRegistrazione: plcConfiguration.recordingStartTime ?? null,
        tFineRegistrazione: plcConfiguration.recordingEndTime ?? null,
        tTempoRegistrazione: plcConfiguration.recordingTime ?? null,
        iSamplingFrequency: plcConfiguration.samplingFrequency,
        variant: plcConfiguration.variant,
    }
}

export { mapToConfigPlcDto, mapToPLCConfiguration }
